import { createAsyncThunk } from '@reduxjs/toolkit';
import { MetaTagsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { META_TAGS_SLICE_NAME } from './models';
import {
  ICreateMetaTagDTO,
  IDeleteMetaTagDTO,
  IGetMetaTagDTO,
  IGetMetaTagResponse,
  IGetMetaTagsDTO,
  IGetMetaTagsResponse,
  IUpdateMetaTagDTO,
} from '@/models/metaTags.model';

export const getMetaTags = createAsyncThunk<IGetMetaTagsResponse, IGetMetaTagsDTO, { serializedErrorType: IApiError }>(
  `${META_TAGS_SLICE_NAME}/getMetaTags`,
  async (data) => {
    const response = await MetaTagsAPI.getMetaTags(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createMetaTag = createAsyncThunk<
  IGetMetaTagResponse,
  ICreateMetaTagDTO,
  { serializedErrorType: IApiError }
>(
  `${META_TAGS_SLICE_NAME}/createMetaTag`,
  async (data) => {
    const response = await MetaTagsAPI.createMetaTag(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getMetaTag = createAsyncThunk<IGetMetaTagResponse, IGetMetaTagDTO, { serializedErrorType: IApiError }>(
  `${META_TAGS_SLICE_NAME}/getMetaTag`,
  async (data) => {
    const response = await MetaTagsAPI.getMetaTag(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateMetaTag = createAsyncThunk<
  IGetMetaTagResponse,
  IUpdateMetaTagDTO,
  { serializedErrorType: IApiError }
>(
  `${META_TAGS_SLICE_NAME}/updateMetaTag`,
  async (data) => {
    const response = await MetaTagsAPI.updateMetaTag(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteMetaTag = createAsyncThunk<void, IDeleteMetaTagDTO, { serializedErrorType: IApiError }>(
  `${META_TAGS_SLICE_NAME}/deleteMetaTag`,
  async (data) => {
    const response = await MetaTagsAPI.deleteMetaTag(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
